import type { BadgeProps } from "@/components/Badge.tsx";
import type { EnumProps } from "@/components/EnumBadge.tsx";
import { Trans } from "@lingui/react/macro";
import type { MetalCommitmentStatusEnum, MetalTemporalStatusEnum } from "@warrenio/api-spec/spec.oats.gen";
import type { ReactNode } from "react";

const commitmentStatuses: MetalCommitmentStatusEnum[] = [
    "requested",
    "billed",
    "allocated",
    "ended",
    "cancelled",
] as const;

const statusLabels = {
    requested: <Trans comment="Metal commitment status">Requested</Trans>,
    billed: <Trans comment="Metal commitment status">Billed</Trans>,
    allocated: <Trans comment="Metal commitment status">Allocated</Trans>,
    ended: <Trans comment="Metal commitment status">Ended</Trans>,
    cancelled: <Trans comment="Metal commitment status">Cancelled</Trans>,
} satisfies Record<MetalCommitmentStatusEnum, ReactNode>;

const statusColors = {
    requested: "warning",
    billed: "success",
    allocated: "warning",
    ended: "error",
    cancelled: "error",
} satisfies Record<MetalCommitmentStatusEnum, BadgeProps["color"]>;

const coverageStatuses: MetalTemporalStatusEnum[] = ["past", "current", "future"] as const;

export const coverageDescriptions: Record<MetalTemporalStatusEnum, EnumProps> = {
    past: { label: <Trans comment="Metal coverage status">Past</Trans>, color: "default" },
    current: { label: <Trans comment="Metal coverage status">Current</Trans>, color: "primary" },
    future: { label: <Trans comment="Metal coverage status">Future</Trans>, color: "success" },
};
